{
  "title": "Users",
  "description": "Dashboard and operator users",
  "actions": {
    "add": "Add User"
  },
  "columns": {
    "name": "Name",
    "username": "Username",
    "group": "Group",
    "branches": "Branches",
    "status": "Status",
    "lastLogin": "Last Login"
  },
  "neverLoggedIn": "Never logged in",
  "list": {
    "ariaLabel": "Users",
    "searchPlaceholder": "Search by name or username"
  },
  "rowActions": {
    "edit": "Edit",
    "resetPassword": "Reset Password",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "delete": "Delete"
  },
  "drawer": {
    "createTitle": "Add User",
    "editTitle": "Edit User",
    "lookup": {
      "label": "Search for an employee by username",
      "placeholder": "Username",
      "search": "Search",
      "searching": "Searching...",
      "notFound": "No employee found with this username. You can create a new employee with this name.",
      "alreadyUser": "This employee already has a Fuel user.",
      "found": "Found: {{name}}",
      "useNew": "Use a new employee instead"
    },
    "fields": {
      "username": "Username",
      "nameAr": "Arabic Name",
      "nameEn": "English Name",
      "email": "Email",
      "phone": "Phone",
      "group": "Group",
      "branches": "Branches"
    },
    "submit": "Save",
    "cancel": "Cancel",
    "discard": {
      "title": "Discard changes?",
      "description": "What you entered for this user will not be saved.",
      "confirmLabel": "Discard",
      "cancelLabel": "Keep editing"
    },
    "created": "User created successfully",
    "updated": "User updated successfully"
  },
  "statusConfirm": {
    "activateTitle": "Activate {{name}}?",
    "activateDescription": "This user will be able to sign in again.",
    "deactivateTitle": "Deactivate {{name}}?",
    "deactivateDescription": "This user will not be able to sign in until reactivated.",
    "confirmActivate": "Activate",
    "confirmDeactivate": "Deactivate"
  },
  "deleteConfirm": {
    "title": "Delete {{name}}?",
    "description": "This user will be permanently deleted. This action cannot be undone.",
    "confirm": "Delete"
  },
  "resetConfirm": {
    "title": "Reset {{name}}'s password?",
    "description": "The current password will be revoked and a new setup link created.",
    "confirm": "Reset"
  },
  "passwordLink": {
    "resetTitle": "Password reset",
    "createTitle": "User created",
    "emailedDescription": "A setup link was emailed to the employee's address.",
    "linkDescription": "Copy this one-time link and share it with the employee:",
    "copy": "Copy link",
    "copied": "Copied",
    "close": "Close"
  },
  "toasts": {
    "statusChanged": "User status changed successfully",
    "deleted": "User deleted successfully",
    "passwordReset": "Password reset successfully"
  },
  "platformAccess": {
    "operator": "Operator",
    "dashboard": "Dashboard"
  }
}
